class SiteFeedbackWidget extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.trigger = this.querySelector('.sfw-trigger');
        this.popup = this.querySelector('.sfw_pop');
        this.closeButton = this.querySelectorAll('[close-trigger]');
        this.form = this.querySelector('form');
        this.formTarget = "https://hook.us1.make.com/vkrhj7gam09relssmvh8l53dop4xf8lu";
        this.botCheck = false;
        this.prompt = this.querySelector("#prompt");
        this.other = this.querySelector("#other");
        this.prompt.addEventListener('change', function() {
          if(this.prompt.value == "Other"){
            this.other.style.display = "block";
            this.other.focus();
          }
          else{
            this.other.style.display = "none";
          }
        }.bind(this));
        this.trigger.addEventListener('click', function() {
            this.popup.style.display = "block";
            this.style.zIndex = "100";
            document.querySelector('#gorgias-chat-container').style.display = "none";
        }.bind(this));
        this.closeButton.forEach(function(icon) {
            icon.addEventListener("click", function() {
                this.popup.style.display = 'none';
                this.style.zIndex = "2";
                document.querySelector('#gorgias-chat-container').style.display = "block";
            }.bind(this));
        }.bind(this));
       this.form.addEventListener("submit", function(event) {
         event.preventDefault();
         this.formSubmit();
       }.bind(this));
      window.setTimeout(() => { this.botCheck = true}, 5000);
    }
    formSubmit(){
      if(window.innerWidth > 768){
        this.querySelector("#device-type").value = "desktop"
      }
      var formData = new FormData(this.form);
      if(this.prompt.value == "Other"){
        formData.set("prompt", this.other.value);
      }
      var currSelector = this;
      if(this.botCheck){
      fetch(this.formTarget, {
        method:'post', 
        body: formData
      }).then(function(data){
        currSelector.querySelector('.completed_message').style.display = "block";
        currSelector.form.style.display = "none";
      });
      }
      else{
        currSelector.querySelector('.completed_message').style.display = "block";
        currSelector.form.style.display = "none";
      }
    }
}
customElements.define('site-feedback-widget', SiteFeedbackWidget)